const toFixed = (value, decimals = 2) => {
  return Number(value).toFixed(decimals);
};

export const clientReceptionColumns = () => [
  {
    id: 'numeroLote',
    label: 'Lote',
    type: 'text',
    isForm: false,
    isFilter: true,
    width: '8%',
    render: (item) => item.numeroLote || 'N/A',
  },
  {
    id: 'estado',
    label: 'Estado',
    type: 'select',
    isForm: false,
    isFilter: true,
    width: '10%',
    options: [
      { value: 'pendiente', label: 'Pendiente' },
      { value: 'finalizado', label: 'Finalizado' }
    ],
    render: (item) => {
      const estado = item.estado || 'pendiente';
      let className = "px-2 py-0.5 rounded-full text-xs font-semibold ";
      if (estado === 'finalizado') {
        className += "bg-green-100 text-green-700 border border-green-200";
      } else {
        className += "bg-yellow-100 text-yellow-700 border border-yellow-200";
      }
      return <span className={className}>{estado.charAt(0).toUpperCase() + estado.slice(1)}</span>;
    },
  },
  {
    id: 'createdAt',
    label: 'Fecha Pesaje',
    type: 'date',
    isForm: false,
    isFilter: true,
    filterType: 'daterange',
    width: '12%',
    render: (item) => new Date(item.createdAt).toLocaleString(),
  },
  {
    id: 'tipoPrenda',
    label: 'Tipo Prenda',
    type: 'text',
    isForm: false,
    isFilter: false,
    width: '12%',
    render: (item) => {
      if (!item.tipoPrenda?.nombre) return 'N/A';
      const fullName = item.tipoPrenda.nombre;
      const truncated = fullName.length > 15 ? `${fullName.substring(0, 15)}...` : fullName;
      return (
        <span title={fullName} className="truncate inline-block max-w-[150px] cursor-help">
          {truncated}
        </span>
      );
    },
  },
  {
    id: 'pesoKg',
    label: 'Peso Total (Kg)',
    type: 'number',
    isForm: false,
    isFilter: false,
    width: '10%',
  },
  {
    id: 'porcentajeRechazo',
    label: '% Rechazo',
    type: 'text',
    isForm: false,
    isFilter: false,
    width: '8%',
    render: (item) => {
      if (!item.totalRechazoKilos || !item.pesoKg) return '-';
      return (
        <span className="text-rose-600 font-medium">
          {toFixed(item.totalRechazoKilos / item.pesoKg * 100, 2)}%
        </span>
      );
    },
  },
  {
    id: 'programaLavado',
    label: 'Programa Lavado',
    type: 'text',
    isForm: false,
    isFilter: false,
    width: '12%',
    render: (item) => {
      if (!item.programaLavado?.nombre) return 'N/A';
      const numero = item.programaLavado.numero_programa || '';
      const nombre = item.programaLavado.nombre;
      const fullName = numero ? `${numero} - ${nombre}` : nombre;
      const truncated = fullName.length > 15 ? `${fullName.substring(0, 15)}...` : fullName;
      return (
        <span title={fullName} className="truncate inline-block max-w-[150px] cursor-help">
          {truncated}
        </span>
      );
    },
  },
  {
    id: 'kilosLimpios',
    label: 'Kilos Limpios',
    type: 'text',
    isForm: false,
    isFilter: false,
    width: '8%',
    render: (item) => {
      if (!item.kilosLimpios) return '-';
      return (
        <span className="text-blue-600 font-medium">
          {item.kilosLimpios} kg
        </span>
      );
    },
  },
  {
    id: 'totalRechazoKilos',
    label: 'Kilos Rechazo',
    type: 'text',
    isForm: false,
    isFilter: false,
    width: '8%',
    render: (item) => {
      if (!item.totalRechazoKilos) return '-';
      return (
        <span className="text-rose-600 font-medium">
          {item.totalRechazoKilos} kg
        </span>
      );
    },
  },
  {
    id: 'observaciones',
    label: 'Observaciones',
    type: 'text',
    isForm: false,
    isFilter: false,
    width: '12%',
  },
];

// Columnas para la exportación a Excel del portal de clientes
export const clientColumnsExcel = [
  { header: 'Lote', key: 'numeroLote', width: 15 },
  { header: 'Estado', key: 'estado', width: 15 },
  { header: 'Fecha Pesaje', key: 'fechaPesaje', width: 20 },
  { header: 'Tipo de Prenda', key: 'tipoPrenda', width: 25 },
  { header: 'Peso Total (Kg)', key: 'pesoKg', width: 20 },
  { header: 'Total Limpios (Kg)', key: 'kilosLimpios', width: 20 },
  { header: 'Total Rechazo (Kg)', key: 'totalRechazoKilos', width: 20 },
  { header: "Arrastre", key: 'arrastre', width: 20 },
  { header: "Cloro", key: 'cloro', width: 20 },
  { header: "Grasa", key: 'grasa', width: 20 },
  { header: "Tintas", key: 'tintas', width: 20 },
  { header: "Oxido", key: 'oxido', width: 20 },
  { header: "Clorhexidina", key: 'clorhexidina', width: 20 },
  { header: "Pegante", key: 'pegante', width: 20 },
  { header: "Azul de metileno", key: 'azul_de_metileno', width: 20 },
  { header: "Otro", key: 'otro', width: 20 },
  { header: 'Programa de Lavado', key: 'programaLavado', width: 25 },
  { header: 'Observaciones', key: 'observaciones', width: 40 },
];
